type Line = {
  itemtype: 'Inventory' | 'Service' | 'FixedAsset';
  itemcode?: string;
  itemdescription?: string;
  u_item_details?: string;
  quantity: number;
  uomcode?: string;
  unitprice: number;
  accountcode: string;
  vendorcode?: string;
  warehouse?: string;
  projectcode?: string;
  dim1?: string;
  dim2?: string;
  dim3?: string;
  dim4?: string;
  dim5?: string;
  deliverydate?: string;
  u_ser_qty?: number | null;
  u_ser_unit_price?: number | null;
};

export type TransformedPRData = {
  requisitionType: 'Inventory' | 'Service' | 'FixedAsset';
  allocationType: 'Project' | 'CostCenter';
  allocationCode: string;
  facilityType: string;
  cycle: string;
  requiredDate: string;
  remarks: string;
  lines: Line[];
};

function getDefaultDeliveryDate(): string {
  const today = new Date();
  const futureDate = new Date(today);
  futureDate.setDate(futureDate.getDate() + 7);

  const year = futureDate.getFullYear();
  const month = String(futureDate.getMonth() + 1).padStart(2, '0');
  const day = String(futureDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function transformPRForCopy(sourcePR: any): TransformedPRData {
  const defaultDeliveryDate = getDefaultDeliveryDate();

  // Explicitly exclude database-generated fields that should not be copied
  const { prid, prnumber, prdate, status, createddate, lastmodifieddate, requestedbyuserid, sappodocentry, sappodocnum, convertedtopo, currentstep, currentapproveruserid, rejectionreason, isbudgetoverridden, budgetoverrideby, budgetoverridereason, ...safeSource } = sourcePR;

  return {
    requisitionType: String(safeSource.requisitiontype || 'Inventory') as 'Inventory' | 'Service' | 'FixedAsset',
    allocationType: String(safeSource.allocationtype || 'Project') as 'Project' | 'CostCenter',
    allocationCode: String(safeSource.allocationcode || ''),
    facilityType: String(safeSource.facilitytype || 'NA'),
    cycle: String(safeSource.cycle || 'Project'),
    requiredDate: defaultDeliveryDate,
    remarks: '',
    lines: (safeSource.lines || []).map((line: any) => {
      // Exclude line-level database-generated fields
      const { lineid, prid, linetotal, convertedqty, ...safeLine } = line;
      return {
        itemtype: String(safeSource.requisitiontype || 'Inventory') as 'Inventory' | 'Service' | 'FixedAsset',
        itemcode: safeLine.itemcode || '',
        itemdescription: safeLine.itemdescription || '',
        u_item_details: safeLine.u_item_details || safeLine.lineremarks || '',
        quantity: Number(safeLine.quantity || 0),
        uomcode: safeLine.uomcode || '',
        unitprice: Number(safeLine.unitprice || 0),
        u_ser_qty: safeLine.u_ser_qty == null ? null : Number(safeLine.u_ser_qty),
        u_ser_unit_price: safeLine.u_ser_unit_price == null ? null : Number(safeLine.u_ser_unit_price),
        accountcode: safeLine.accountcode || '',
        vendorcode: '',
        warehouse: safeLine.warehouse || '',
        projectcode: safeLine.projectcode || '',
        dim1: safeLine.dim1 || '',
        dim2: safeLine.dim2 || '',
        dim3: safeLine.dim3 || '',
        dim4: safeLine.dim4 || '',
        dim5: safeLine.dim5 || '',
        deliverydate: defaultDeliveryDate
      };
    })
  };
}
